import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { FormattedMessage } from 'react-intl';
import { TypeaheadComponent } from '../../atoms/typeahead/Typeahead.component';

export default function WishListAuthModalFormComponent(props: any) {
  const {
    showModal,
    handleClose,
    authUsers,
    removeAuthUser,
    options,
    addRef,
    handleInputChange,
    handleOnBlur,
    handleAddNewSelected,
    submitSelected
  } = props;

  function resetModal() {
    handleClose();
  }

  return (
    <Modal show={showModal} onHide={() => resetModal()} size='xl' centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage id='organisms.wishlist_auth_modal_form.main_title' />
        </Modal.Title>
      </Modal.Header>
        <Modal.Body>
          <div className='form-field-container'>
            <FormattedMessage id='organisms.wishlist_auth_modal_form.placeholder'>
              {(txt: any) => (
                <TypeaheadComponent
                  label={txt}
                  addRef={addRef}
                  handleInputChange={handleInputChange}
                  handleOnBlur={handleOnBlur}
                  options={options}
                  withList={true}
                  oldSelected={authUsers}
                  handleRemoveOldSelected={removeAuthUser}
                  handleAddNewSelected={handleAddNewSelected}
                />
              )}
            </FormattedMessage>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className='btn-lili form-button danger mb-3 cancel-btn'
            onClick={() => resetModal()}
          >
            <FormattedMessage id='common.cancel'></FormattedMessage>
          </button>
          <button onClick={() => submitSelected()} className='btn-lili form-button  mb-3' >
            <FormattedMessage id='common.save'></FormattedMessage>
          </button>
        </Modal.Footer>
    </Modal>
  );
}
